import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import GenericProviderFieldDialog from "../../GenericProviderFieldDialog";
import {updateProviderGoogleBusinessProfileId, updateProviderPlace} from "../../networking";
import {useDictionary} from "../../../../../../../utilities/hooks/UseDictionary";

const ProviderGttd = ({ gttd, providerId, placeId, isMatched, onSuccess }) => {
    const [isCollapsed, setIsCollapsed] = useState(true); // State for collapse/expand
    const [showProviderPlaceDialog, setProviderPlaceVisibility] = useState(false);
    const [showProviderGoogleBusinessProfileIdDialog, setProviderGoogleBusinessProfileIdVisibility] = useState(false);

    const dictionary = useDictionary();

    let parsedGttd = {};
    try {
        parsedGttd = gttd ? gttd : {};
    } catch (error) {
        parsedGttd = { error: "Invalid JSON format" };
    }

    const handleProviderPlaceUpdate = async (newPlaceId) => {
        await updateProviderPlace(providerId, newPlaceId); // Wait for the API call
        if (onSuccess) {
            await onSuccess(); // Wait for the parent to re-fetch and update state
        }
        setProviderPlaceVisibility(false); // Close the dialog
    };

    const handleProviderGoogleBusinessProfileId = async (newGoogleBusinessProfileId) => {
        await updateProviderGoogleBusinessProfileId(providerId, newGoogleBusinessProfileId); // Wait for the API call
        if (onSuccess) {
            await onSuccess(); // Wait for the parent to re-fetch and update state
        }
        setProviderGoogleBusinessProfileIdVisibility(false); // Close the dialog
    };


    return (
        <div className="booking-experience-images-container-wrapper">
            <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{
                    marginBottom: "10px",
                    padding: "5px 10px",
                    cursor: "pointer",
                    backgroundColor: "#007BFF",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px"
                }}>
                {isCollapsed ? "Expand JSON" : "Collapse JSON"}
            </button>

            {!isMatched ? (
                <button
                    onClick={() => setProviderPlaceVisibility(true)}
                    style={{
                        marginLeft: "10px",
                        marginBottom: "10px",
                        padding: "5px 10px",
                        cursor: "pointer",
                        backgroundColor: "#007BFF",
                        color: "#fff",
                        border: "none",
                        borderRadius: "5px"
                    }}>
                    Set Provider Place
                </button>
            ): null}

            <button
                onClick={() => setProviderGoogleBusinessProfileIdVisibility(true)}
                style={{
                    marginLeft: "10px",
                    marginBottom: "10px",
                    padding: "5px 10px",
                    cursor: "pointer",
                    backgroundColor: "#007BFF",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px"
                }}>
                Set Google Business Profile Id
            </button>

            <ReactJson
                src={parsedGttd}
                theme="monokai"
                collapsed={isCollapsed}
                displayDataTypes={false}
                enableClipboard={true}
            />

            {showProviderPlaceDialog ? (
                <GenericProviderFieldDialog
                    dialogTitle={dictionary.set_provider_place_id}
                    initialValue={placeId}
                    label="Place Id"
                    onUpdate={handleProviderPlaceUpdate}
                    setDialogVisibility={setProviderPlaceVisibility}
                />
            ) : null}
            {showProviderGoogleBusinessProfileIdDialog ? (
                <GenericProviderFieldDialog
                    dialogTitle={dictionary.set_provider_google_business_profile_id}
                    initialValue={parsedGttd?.google_business_profile_id ? parsedGttd?.google_business_profile_id : ""}
                    label="ID"
                    onUpdate={handleProviderGoogleBusinessProfileId}
                    setDialogVisibility={setProviderGoogleBusinessProfileIdVisibility}
                    allowEmpty={true}
                />
            ) : null}
        </div>
    );
};

ProviderGttd.propTypes = {
    gttd: PropTypes.object,
    providerId: PropTypes.string,
    placeId: PropTypes.string,
    isMatched: PropTypes.bool,
    onSuccess: PropTypes.func
};

ProviderGttd.defaultProps = {
    isMatched: false
};

export default ProviderGttd;
